<div class="autocomplete" [class.autocomplete--with-button]="showButton">
  <ng-select
    #select
    bindLabel="label"
    class="custom"
    [class.hide-arrow]="!loadOnFocus"
    [clearable]="false"
    [clearAllText]="'RydAlt' | tekstresource"
    [disabled]="disableSearch$ | async"
    [isOpen]="dropdownOpen"
    [items]="items"
    [loading]="searchLoading"
    [loadingText]="'Henter' | tekstresource"
    [(ngModel)]="selectedItem"
    [notFoundText]="notFoundText"
    [placeholder]="placeholder"
    [typeahead]="typeahead$"
    [typeToSearchText]="'SkrivIFeltForAtSoege' | tekstresource"
    (blur)="onBlur()"
    (change)="onChange($event)"
    (click)="onClick()"
    (focus)="onFocus()"
    (keydown.enter)="onEnter()"
    (search)="onSearch($event)"
  >
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div [innerHtml]="item.option || item.label"></div>
    </ng-template>
  </ng-select>
  <button
    *ngIf="showButton"
    class="button button-secondary"
    (click)="onButtonClick()"
    (keydown.enter)="onButtonClick()"
    (blur)="onBlur()"
  >
    <svg class="icon-svg"><use xlink:href="#magnify"></use></svg><span class="sr-only">Søg</span>
  </button>
</div>
